import APIService from 'services/APIService';
import { IReceipt } from 'types';

export class ReceiptsAPI extends APIService {
  item = (id: string) => this.client.get<IReceipt>(`pos/receipts/${id}`);
}

export const receiptsAPI = new ReceiptsAPI();
